var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ld-section-title",style:(("color:" + _vm.color + ";margin: " + _vm.margin))},[_vm._t("default",[_vm._v("默认标题")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }